<template>
  <div class="dashboard-page admin-dashboard">
    <h1 class="page-header color-1-100">Welcome to your dashboard!</h1>
    <div class="flex-block">
      <div class="content-right-section anchors">
        <div class="sticky-anchors background-1-40-before" tabindex="-1">
          <div class="anchor-item color-1-20 companies" :class="[{ 'active  color-1-100': activeSection === 'dashboardCompanies' }]">
            <a href="#" @click.prevent="goToPageSection('dashboardCompanies')">Companies and Users</a>
          </div>
          <div class="anchor-item color-1-20 searches" :class="[{ 'active  color-1-100': activeSection === 'dashboardSearches' }]">
            <a href="#" @click.prevent="goToPageSection('dashboardSearches')">Popular Searches</a>
          </div>
        </div>
      </div>
      <div class="content-left-section">
        <div class="content-section company-section no-margin-top"
             tabindex="-1"
             ref="dashboardCompanies">
          <h3 class="content-section-title color-1-100 background-1-100-before">
            Companies and users
          </h3>
          <div class="flex-section">
            <div class="companies-section">
              <div class="section-head has-icon">
                <span class="section-title company-icon">
                  Companies
                </span>
                <div class="section-actions">
                  <router-link :to="{ name: 'companies' }" class="action-all">See all</router-link>
                  <router-link :to="{ name: 'add-company' }" class="action-add">Add new</router-link>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="section-body">
                <router-link :to="{ name: 'companies', query: { status: index } }" class="section-item"
                             v-bind:key="index"
                             v-for="(count, index) in companies">
                  <div class="item-title">
                    {{ getCompanyStatus(index) }}
                  </div>
                  <div class="item-meta">
                    <span class="item-count">{{ count }}</span>
                    <span class="item-arrow"></span>
                  </div>
                  <div class="clearfix"></div>
                </router-link>
              </div>
            </div>
            <div class="users-section">
              <div class="section-head has-icon">
                <span class="section-title user-icon">
                  Users
                </span>
                <div class="section-actions">
                  <router-link :to="{ name: 'users' }" class="action-all">See all</router-link>
                  <router-link :to="{ name: 'add-user' }" class="action-add">Add new</router-link>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="section-body">
                <router-link :to="{ name: 'users', query: { role: user.slug } }" class="section-item"
                             v-bind:key="user.slug"
                             v-for="user in users">
                  <div class="item-title">
                    {{ getUserRoleName(user.slug) }}
                  </div>
                  <div class="item-meta">
                    <span class="item-count">{{ user.c }}</span>
                    <span class="item-arrow"></span>
                  </div>
                  <div class="clearfix"></div>
                </router-link>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="content-section searches-section"
             tabindex="-1"
             ref="dashboardSearches">
          <h3 class="content-section-title color-1-100 background-1-100-before">
            Popular searches in the past 30 days
          </h3>
          <div class="flex-section">
            <div class="companies-section">
              <div class="section-head">
                <span class="section-title">
                  Searches with 0 results
                </span>
                <div class="clearfix"></div>
              </div>
              <div class="section-body">
                <div class="section-item" v-for="item in topZeroSearch">
                  <div class="item-title">
                    {{ item.search }}
                  </div>
                  <div class="item-meta">
                    <span class="item-count">{{ item.count }}</span>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
            <div class="users-section">
              <div class="section-head">
                <span class="section-title">
                  Searches with results
                </span>
                <div class="clearfix"></div>
              </div>
              <div class="section-body">
                <div class="section-item" v-for="item in topSearch">
                  <div class="item-title">
                    {{ item.search }}
                  </div>
                  <div class="item-meta">
                    <span class="item-count">{{ item.count }}</span>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import api from '@/api'

export default {
  name: 'admin-app',
  data () {
    return {
      companies: null,
      users: null,
      topZeroSearch: null,
      topSearch: null,
      activeSection: 'dashboardCompanies'
    }
  },
  computed: {
    ...mapGetters([
      'getUserRole'
    ])
  },
  components: {},
  methods: {
    ...mapActions([]),
    getCounters () {
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.dashboardCounters, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.companies = res.body.companies
        this.users = res.body.users
        this.$nextTick(() => {
          this.getTopSearch()
        })
      }).catch(() => {
        this.disableAPI = false
      })
    },
    getCompanyStatus (status) {
      let response
      if (status === 'active') {
        response = 'Active companies'
      } else if (status === 'notactive') {
        response = 'Expired companies'
      } else {
        response = 'Archived companies'
      }
      return response
    },
    getUserRoleName (slug) {
      let response
      if (slug === 'gm') {
        response = 'God mode users'
      } else if (slug === 'ca') {
        response = 'Company admin users'
      } else if (slug === 'sh') {
        response = 'Company stakeholders users'
      } else if (slug === 'ta') {
        response = 'Toolkit admin users'
      } else if (slug === 'tu') {
        response = 'Toolkit user users'
      } else if (slug === 'la') {
        response = 'Light admin users'
      } else if (slug === 'lu') {
        response = 'Light user users'
      } else {
        response = 'Regular users'
      }
      return response
    },
    getTopZeroSearch () {
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.topZeroSearch, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.topZeroSearch = res.body
      }).catch(() => {
        this.disableAPI = false
      })
    },
    getTopSearch () {
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.topSearch, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.topSearch = res.body
        this.$nextTick(() => {
          this.getTopZeroSearch()
        })
      }).catch(() => {
        this.disableAPI = false
      })
    },
    goToPageSection (ref) {
      let element = this.$refs[ref]
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        element.focus()
      }
    },
    posY (elm) {
      let test = elm
      let top = 0
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop
        test = test.offsetParent
      }
      return top
    },
    scrollY () {
      if (window.pageYOffset) {
        return window.pageYOffset
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    },
    isScrolledIntoView (elem) {
      let docViewTop = this.scrollY()
      let docViewBottom = docViewTop + window.outerHeight
      let elemTop = this.posY(elem) - 10
      let elemBottom = elemTop + elem.offsetHeight
      return ((elemBottom <= docViewBottom) && (elemTop <= docViewTop))
    },
    handleScroll () {
      let sections = this.$refs
      for (let index in sections) {
        let section = sections[index]
        if (section && this.isScrolledIntoView(section)) {
          this.activeSection = index
        }
      }
    }
  },
  watch: {
  },
  created () {
    this.getCounters()
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted () {
    document.title = 'Admin dashboard | Clear Assured'
    if (window.ga) {
      window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      window.ga('send', 'pageview', {
        'page': location.pathname,
        'location': location.href,
        'title': document.title
      })
    }
  },
  beforeMount () {
    this.userData = JSON.parse(localStorage.getItem('userData'))
    if (this.userData.userRole !== 'gm' && this.$route.path === '/admin') {
      this.$router.push({
        path: '/'
      })
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style src="@/assets/scss/components/dashboard.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// AdminDashboard.vue?28f2c1b6